export enum LocalStorageKey {
  ASK_PRODUCT_MODAL_TIMESTAMP = 'APQ-V2-timestamp',
  INFO_USER_LOCALSTORAGE = 'mage-cache-storage',
}

export const updateAskProductModalTimestamp = () => {
  localStorage.setItem(
    LocalStorageKey.ASK_PRODUCT_MODAL_TIMESTAMP,
    String(Date.now()),
  );
};

export const getAskProductModalTimestamp = () => {
  return JSON.parse(
    localStorage.getItem(LocalStorageKey.ASK_PRODUCT_MODAL_TIMESTAMP) ?? '0',
  );
};

export const shouldTriggerAskProductModalDialog = () => {
  const selectProjectTimestamp = getAskProductModalTimestamp();
  const currentTimestamp = Date.now();
  return currentTimestamp - selectProjectTimestamp > 172800000; // 48 hours
};

export const getUserAttributes = () => {
  return (
    JSON.parse(
      localStorage.getItem(LocalStorageKey.INFO_USER_LOCALSTORAGE) || '{}',
    )?.customer || {}
  );
};
